import { useEffect } from "react";
import { baseUrl } from "../../api";
import useUserAuth from "../../hook/useUserAuth";

const GoogleLogin = ({ handleGoogleLogin }) => {
  const { setUserAuth, setTokenData } = useUserAuth();

  const initClient = () => {
    window.google.accounts.id.initialize({
      client_id: baseUrl.GOOGLE_CLIENT_ID,
      callback: handleCredentialResponse,
      use_fedcm_for_prompt: true
    });
    window.google.accounts.id.renderButton(
      document.getElementById('buttonDiv'),
      {
        theme: 'outline',
        size: 'large',
        width: '280px'
      }
    );
    window.google.accounts.id.prompt();
  }

  useEffect(() => {
    const gsi = document.querySelector('#google-gsi-script');

    if (!window.google) {
      gsi.addEventListener('load', initClient);
    } else {
      initClient();
    };

    return () => gsi.removeEventListener('load', initClient);

  }, [])

  const handleCredentialResponse = async (response) => {
    let id_token = response.credential;

    handleGoogleLogin(id_token);
  };


  return (
    <>
      <div id="buttonDiv" />
    </>
  )
}

export default GoogleLogin;